var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBus = function SvgBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.657 2.842C1.741 2.842 1 3.584 1 4.5v7.109c0 .5.405.904.904.904h.237a1.847 1.847 0 0 0 3.674 0h4.388a1.847 1.847 0 0 0 3.674 0h.236c.5 0 .904-.405.904-.904V9.115a.9.9 0 0 0-.1-.415l-1.26-2.443c-.31-.601-.93-.98-1.607-.98h-2.006V4.5c0-.916-.742-1.658-1.658-1.658zm7.516 3.265h1.929a.98.98 0 0 1 .87.53l.95 1.844h-3.75zm1.866 7.235a1.017 1.017 0 1 0 0-2.035 1.017 1.017 0 0 0 0 2.035m-7.044-1.017a1.017 1.017 0 1 1-2.035 0 1.017 1.017 0 0 1 2.035 0",
    clipRule: "evenodd"
  })));
};
export default SvgBus;